import {Links, Site, SiteState} from '../interfaces';

export const getters = {
  customerId: (state: SiteState): string => state.customerId,
  error: (state: SiteState): boolean => state.error,
  enableContact: (state: SiteState): boolean => state.enableContact,
  enableFeedback: (state: SiteState): boolean => state.enableFeedback,
  isBookingActivated: (state: SiteState): boolean => state.isBookingActivated,
  isDemo: (state: SiteState): boolean => state.isDemo,
  isOpenSelector: (state: SiteState): boolean => state.isOpenSelector,
  links: (state: SiteState): Links | null => state.links,
  loading: (state: SiteState): boolean => state.loading,
  motd: (state: SiteState): string | null => state.motd,
  name: (state: SiteState): string => state.name,
  slug: (state: SiteState): string => state.slug,
  siteList: (state: SiteState): Site[] => state.siteList,
};
